import React from "react";
import ImumToAkeneoScreen from "../ImumToAkeneoScreen";

export default function ImumPage({ match }) {
  return <ImumToAkeneoScreen match={match} record_type={"bigbox"} />;
}
